import { MoreActionsDropdown } from 'module/ui/components/atoms/more-actions';
import {
  HeadingCompact01,
  Short01,
  SingleLineEllipsis,
} from 'module/ui/components/styles';
import { PageTemplateSectionSource } from 'api/custom-section/types';
import { FC, useCallback } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

const Title = styled.div`
  ${HeadingCompact01};
  color: var(--black-100);
  ${SingleLineEllipsis};
`;
const Description = styled.div`
  ${Short01};
  color: var(--text-primary);
  ${SingleLineEllipsis};
`;
const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--spacing-02);
  width: 100%;
  overflow: hidden;
`;
const HeaderRow = styled.div`
  display: flex;
  align-items: center;
  gap: var(--spacing-05);
`;
const FooterRow = styled.div`
  color: var(--text-tertiary);
`;
const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--spacing-05);
  padding: var(--spacing-05);
  border-radius: var(--border-radius-small);
  border: 1px solid var(--rte-section-node-border);
`;
const moreActionsMenu = () => [
  {
    type: 'group' as const,
    label: <FormattedMessage id="more_actions" />,
    children: [
      {
        key: 'insert_as_new_section',
        label: (
          <FormattedMessage id="company_page_templates.sections.sources.insert_as_new_section" />
        ),
      },
      {
        key: 'remove',
        label: <FormattedMessage id="remove" />,
        danger: true,
      },
    ],
  },
];

interface Props {
  source: PageTemplateSectionSource;
  onRemove: () => void;
  onInsertAsNewSection: () => void;
}
export const SectionSourcRenderer: FC<Props> = ({
  source,
  onRemove,
  onInsertAsNewSection,
}) => {
  const onMenuClick = useCallback(
    ({ key }: { key: string }) => {
      if (key === 'remove') {
        onRemove();
      } else if (key === 'insert_as_new_section') {
        onInsertAsNewSection();
      }
    },
    [onRemove, onInsertAsNewSection],
  );

  return (
    <Wrapper>
      <HeaderRow>
        <Content>
          <Title>{source.pageTemplateSectionTitle}</Title>
          <Description>{source.pageTemplateSectionContent}</Description>
        </Content>
        <MoreActionsDropdown
          menu={{
            onClick: onMenuClick,
            items: moreActionsMenu(),
          }}
        />
      </HeaderRow>
      <FooterRow>{source.pageTemplateName}</FooterRow>
    </Wrapper>
  );
};
